import { ModularLayoutBasicData } from '../../../../../../data/model';
import Selector from '../../../../../../shared/Selector';

class LayoutPickerState extends Selector<ModularLayoutBasicData> {}

export default LayoutPickerState;
